(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('js-ec-reveal');

  function $all(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function pressGroup(buttons, onPick) {
    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        buttons.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        onPick(b);
      });
    });
  }

  /* ---------- reveal (meters) ---------- */
  var io = null;
  function observeReveal(root) {
    var targets = $all('.ec-biz, .ec-reveal', root);
    if (!('IntersectionObserver' in window) || reduceMotion) {
      targets.forEach(function (t) { t.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
    }
    targets.forEach(function (t) { io.observe(t); });
  }

  /* ---------- header ---------- */
  function initHeader(root) {
    var header = root.querySelector('[data-ec-header]');
    if (!header) return;

    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var menus = $all('details[data-ec-dropdown]', header);
    document.addEventListener('click', function (e) {
      menus.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; });
    });
    header.addEventListener('keyup', function (e) {
      if (e.key !== 'Escape') return;
      menus.forEach(function (d) {
        if (d.open) { d.open = false; d.querySelector('summary').focus(); }
      });
      var drawer = header.querySelector('details[data-ec-drawer]');
      if (drawer && drawer.open) { drawer.open = false; drawer.querySelector('summary').focus(); }
    });
    menus.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) menus.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });

    var drawer = header.querySelector('details[data-ec-drawer]');
    if (drawer) {
      drawer.addEventListener('toggle', function () {
        document.documentElement.style.overflow = drawer.open ? 'hidden' : '';
      });
      $all('[data-ec-drawer-close]', drawer).forEach(function (b) {
        b.addEventListener('click', function () { drawer.open = false; });
      });
    }
  }

  /* ---------- match engine ----------
     Scores every in-stock build from the hero's catalog collections against four answers.
     score = strength-to-model fit (34%) + weekly time fit (26%) + budget fit (10%) + niche fit (20%)
             + Judge.me rating and review volume (10%) + pinned boosts. "Not sure yet" trades 10% of the
             strength weight for ease of starting. Time weighs heavily: too little time is why most builds stall. Weights and tables are tuned for EcomChief's five models. */
  var MATCH = {
    strength: {
      social: { drop: 1, amazon: 0.55, affiliate: 0.45, agency: 0.65, app: 0.35 },
      write: { drop: 0.5, amazon: 0.95, affiliate: 1, agency: 0.55, app: 0.4 },
      talk: { drop: 0.5, amazon: 0.35, affiliate: 0.35, agency: 1, app: 0.55 },
      tools: { drop: 0.45, amazon: 0.55, affiliate: 0.5, agency: 0.6, app: 1 },
      unsure: { drop: 0.8, amazon: 0.85, affiliate: 0.65, agency: 0.45, app: 0.6 }
    },
    // weekly capacity on the same 0-100 scale as a build's "time needed" score
    capacity: { 1: 30, 2: 60, 3: 95 },
    // how much each model leans on paid marketing (0-1); organic video softens dropshipping for social people
    adNeed: { drop: 0.75, amazon: 0.1, affiliate: 0.1, agency: 0.25, app: 0.3 },
    budget: { 0: 0.15, 1: 0.55, 2: 1 },
    niches: {
      fashion: /fashion|apparel|cloth|streetwear|street wear|athleisure|jewel|handbag|heels|swim|lingerie|shoe|sneaker|footwear|watch|sunglass|beauty|makeup|cosmetic|perfume|grooming|skincare|backpack/,
      home: /home|decor|garden|kitchen|furniture|coffee|grocery|food|travel|camping|luggage|discount|astrology|restaurant|wedding|lifestyle/,
      tech: /tech|electronic|gadget|gaming|smart|apple|auto|\bcars?\b|\bai\b|artificial|\bev\b|creator|phone|energy|\bapp\b|\bqr\b/,
      health: /health|fitness|supplement|vitamin|wellness|medical|pharmac|organic|habit|\bgym|yoga|goal tracker/,
      pets: /\bpets?\b/,
      business: /agency|marketing|seo|lead gen|crm|invoice|booking|job board|resume|\bcv\b|assistant|bookkeep|accounting|design|video production|presentation|reputation|link-in-bio|expense|stock market|facebook ads|content writing/
    }
  };

  function fill(str, map) {
    return String(str || '').replace(/\[(\w+)\]/g, function (all, k) { return map[k] != null ? map[k] : all; });
  }

  function scoreBuild(p, a, pins) {
    var aff = (MATCH.strength[a.skill] || MATCH.strength.unsure)[p.m];
    if (aff == null) aff = 0.4;
    var over = (p.tm || 50) - (MATCH.capacity[a.hours] || 60);
    var timeFit = over <= 0 ? 1 : Math.max(0.15, 1 - over / 45);
    var need = MATCH.adNeed[p.m] != null ? MATCH.adNeed[p.m] : 0.3;
    if (p.m === 'drop' && a.skill === 'social') need = 0.4;
    var budgetFit = Math.max(0.2, Math.min(1, 1 - Math.max(0, need - MATCH.budget[a.budget]) * 1.1));
    var inNiche = a.niche !== 'any' && MATCH.niches[a.niche] && MATCH.niches[a.niche].test(String(p.k || p.t).toLowerCase());
    // agencies can serve clients in any industry, so they are never ruled out by niche
    var nicheFit = a.niche === 'any' ? 0.8 : inNiche ? 1 : p.m === 'agency' ? 0.7 : 0.35;
    var r = Math.min(5, parseFloat(p.r) || 0), n = parseInt(p.n, 10) || 0;
    var proof = n ? (r / 5) * 0.6 + 0.4 * Math.min(1, Math.log(n + 1) / Math.LN10 / 2) : 0.45;
    var ease = (p.ez || 50) / 100;
    var unsure = a.skill === 'unsure';
    var s = aff * (unsure ? 0.24 : 0.34) + ease * (unsure ? 0.1 : 0) + timeFit * 0.26 + budgetFit * 0.1 + nicheFit * 0.2 + proof * 0.1;
    pins.forEach(function (pin) {
      if (pin.u === p.u && (pin.s === 'any' || pin.s === a.skill)) s += (pin.b || 0) / 100;
    });
    return { p: p, s: s, fit: Math.max(55, Math.min(98, Math.round(s * 100))), timeOk: over <= 0, inNiche: inNiche, r: r, n: n };
  }

  function initMatch(root) {
    var box = root.querySelector('[data-ec-match]');
    if (!box) return;
    var dataEl = box.querySelector('script[data-ec-match-data]');
    var quiz = box.querySelector('[data-ec-quiz]');
    if (!dataEl || !quiz) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var products = data.products || [], pins = data.pins || [], copy = data.copy || {};
    if (!products.length) return;

    var steps = $all('[data-ec-step]', quiz);
    var total = steps.length;
    var count = quiz.querySelector('[data-ec-qcount]');
    var bar = quiz.querySelector('[data-ec-qbar]');
    var back = quiz.querySelector('[data-ec-back]');
    var stage = box.querySelector('[data-ec-stage]');
    var think = box.querySelector('[data-ec-think]');
    var res = box.querySelector('[data-ec-result]');
    var alts = box.querySelector('[data-ec-alts]');
    var altList = box.querySelector('[data-ec-alts-list]');
    var nudge = box.querySelector('[data-ec-nudge]');
    var restart = box.querySelector('[data-ec-restart]');
    var answers = { skill: 'unsure', hours: '2', budget: '1', niche: 'any' };
    var step = 1;

    function go(n, focus) {
      step = Math.max(1, Math.min(total, n));
      steps.forEach(function (st) { st.hidden = st.getAttribute('data-ec-step') !== String(step); });
      if (count) count.textContent = fill(copy.stepLabel, { n: step, total: total });
      if (bar) bar.style.width = (step / total) * 100 + '%';
      if (back) back.hidden = step === 1;
      if (focus) {
        var target = steps[step - 1].querySelector('[aria-pressed="true"]') || steps[step - 1].querySelector('button');
        if (target) target.focus({ preventScroll: true });
      }
    }

    $all('[data-ec-a]', quiz).forEach(function (b) {
      b.addEventListener('click', function (e) {
        var key = b.getAttribute('data-ec-a');
        $all('[data-ec-a="' + key + '"]', quiz).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        answers[key] = b.getAttribute('data-v');
        var keyboard = e.detail === 0;
        setTimeout(function () {
          if (step < total) go(step + 1, keyboard);
          else run();
        }, reduceMotion ? 0 : 200);
      });
    });
    if (back) back.addEventListener('click', function () { go(step - 1, true); });

    function lower(s) { return s === 'Amazon' ? s : String(s || '').toLowerCase(); }
    function soft(s) { s = String(s || ''); return s.charAt(0).toLowerCase() + s.slice(1); }
    function timeWord(tm) { return copy.time[tm >= 85 ? '3' : tm >= 50 ? '2' : '1']; }
    function niceRating(r) { return String(Math.round(r * 100) / 100); }

    function run() {
      var ranked = products.map(function (p) { return scoreBuild(p, answers, pins); })
        .sort(function (x, y) { return y.s - x.s || y.n - x.n; });
      var top = ranked[0];
      var picks = [];
      var other = ranked.filter(function (x) { return x.p.m !== top.p.m; })[0];
      var same = ranked.filter(function (x) { return x !== top && x.p.m === top.p.m; })[0];
      [other, same].forEach(function (x) { if (x) picks.push(x); });
      if (picks.length < 2) ranked.slice(1).forEach(function (x) { if (picks.length < 2 && picks.indexOf(x) < 0) picks.push(x); });
      picks.sort(function (x, y) { return y.s - x.s; });

      // thinking lines
      var lines = [
        fill(copy.lineSkill, { skill: soft(copy.skill[answers.skill]) }),
        fill(copy.lineScan, { count: products.length }),
        fill(copy.lineTime, { hours: copy.hours[answers.hours], budget: soft(copy.budget[answers.budget]) })
      ];
      if (answers.niche !== 'any') lines.push(fill(copy.lineNiche, { niche: soft(copy.niche[answers.niche]) }));
      think.innerHTML = '';
      lines.forEach(function (line) {
        if (!line) return;
        var li = document.createElement('li');
        var tick = document.createElement('span');
        tick.className = 'ec-tick';
        li.appendChild(tick);
        li.appendChild(document.createTextNode(line));
        think.appendChild(li);
      });

      // headline result
      var p = top.p;
      var why = [copy.why[p.m] || ''];
      why.push(fill(top.timeOk ? copy.txtTimeOk : copy.txtTimeOver, { time: String(timeWord(p.tm) || '').toLowerCase() }));
      if (top.inNiche) why.push(fill(copy.txtNiche, { niche: soft(copy.niche[answers.niche]) }));
      if (top.n >= 5) why.push(fill(copy.txtProof, { rating: niceRating(top.r), count: top.n }));
      var img = res.querySelector('[data-ec-r-img]');
      if (img) {
        if (p.i) { img.src = p.i; img.alt = p.t; img.hidden = false; } else { img.hidden = true; }
      }
      res.querySelector('[data-ec-r-kind]').textContent = p.ml;
      res.querySelector('[data-ec-r-name]').textContent = p.t;
      res.querySelector('[data-ec-r-why]').textContent = why.filter(Boolean).join(' ');
      res.querySelector('[data-ec-r-link]').href = p.u;
      var all = res.querySelector('[data-ec-r-all]');
      if (all && p.c && copy.allLabel) {
        all.href = p.c;
        all.textContent = fill(copy.allLabel, { model: lower(p.ml) });
      }
      res.querySelector('[data-ec-r-pct]').firstChild.nodeValue = top.fit + '%';
      var arc = res.querySelector('[data-ec-r-arc]');
      var circ = parseFloat(arc.getAttribute('stroke-dasharray'));
      arc.setAttribute('stroke-dashoffset', String(circ));
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { arc.setAttribute('stroke-dashoffset', String(circ - (circ * top.fit) / 100)); });
      });

      // runner-ups
      altList.innerHTML = '';
      picks.forEach(function (x) {
        var a = document.createElement('a');
        a.className = 'ec-alt';
        a.href = x.p.u;
        if (x.p.i) {
          var im = document.createElement('img');
          im.src = x.p.i; im.alt = ''; im.width = 56; im.height = 56; im.loading = 'lazy';
          a.appendChild(im);
        }
        var t = document.createElement('span');
        var b = document.createElement('b');
        b.textContent = x.p.t;
        var em = document.createElement('em');
        em.textContent = x.p.ml + ' · ' + x.fit + '% ' + (copy.fitLabel || '');
        t.appendChild(b); t.appendChild(em);
        a.appendChild(t);
        altList.appendChild(a);
      });
      alts.hidden = picks.length === 0;
      if (nudge) nudge.hidden = !(answers.hours === '3' || answers.budget === '2');

      quiz.hidden = true;
      stage.classList.remove('is-on');
      [res, alts, nudge].forEach(function (el) { if (el) { el.style.animation = 'none'; void el.offsetWidth; el.style.animation = ''; } });
      stage.classList.add('is-on');
      box.scrollIntoView({ block: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    if (restart) restart.addEventListener('click', function () {
      stage.classList.remove('is-on');
      quiz.hidden = false;
      $all('[data-ec-a]', quiz).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      go(1, true);
    });

    go(1, false);
  }

  /* ---------- homepage builds filter chips ---------- */
  function initChips(root) {
    $all('[data-ec-chips]', root).forEach(function (group) {
      var grid = root.querySelector('#' + group.getAttribute('aria-controls'));
      if (!grid) return;
      var cards = $all('[data-model]', grid);
      pressGroup($all('[data-ec-chip]', group), function (b) {
        var f = b.dataset.ecChip;
        cards.forEach(function (c) { c.hidden = !(f === 'all' || c.dataset.model === f); });
      });
    });
  }

  /* ---------- collection filters + sort ---------- */
  function initCollection(root) {
    var wrap = root.querySelector('[data-ec-collection]');
    if (!wrap) return;
    var grid = wrap.querySelector('[data-ec-grid]');
    var cards = $all('.ec-biz', grid);
    var strip = grid.querySelector('[data-ec-strip]');
    var stripAfter = parseInt(wrap.dataset.stripAfter, 10) || 6;
    var countEl = wrap.querySelector('[data-ec-count]');
    var actives = wrap.querySelector('[data-ec-actives]');
    var empty = wrap.querySelector('[data-ec-empty]');
    var more = wrap.querySelector('[data-ec-more]');
    var fcount = wrap.querySelector('[data-ec-fcount]');
    var side = wrap.querySelector('[data-ec-side]');
    var sort = wrap.querySelector('[data-ec-sort]');
    var labels = {};
    $all('[data-ec-opt]', wrap).forEach(function (b) { labels[b.dataset.g + ':' + b.dataset.v] = b.dataset.label; });
    var state = {};
    $all('[data-ec-opt]', wrap).forEach(function (b) { state[b.dataset.g] = state[b.dataset.g] || []; });

    function matches(c) {
      return Object.keys(state).every(function (g) {
        return state[g].length === 0 || state[g].indexOf(c.dataset[g]) > -1;
      });
    }

    function placeStrip() {
      if (!strip) return;
      var visible = cards.filter(function (c) { return !c.hidden; });
      strip.hidden = visible.length < stripAfter;
      var anchor = visible[stripAfter - 1];
      if (anchor) anchor.after(strip);
    }

    function render() {
      var shown = 0;
      cards.forEach(function (c) {
        var ok = matches(c);
        c.hidden = !ok;
        if (ok) shown++;
      });
      if (countEl) countEl.textContent = shown;
      if (empty) empty.hidden = shown !== 0;
      if (more) more.hidden = shown === 0;
      placeStrip();

      var total = 0;
      if (actives) {
        actives.innerHTML = '';
        Object.keys(state).forEach(function (g) {
          state[g].forEach(function (v) {
            total++;
            var p = document.createElement('span');
            p.className = 'ec-apill';
            p.appendChild(document.createTextNode(labels[g + ':' + v] || v));
            var x = document.createElement('button');
            x.type = 'button';
            x.setAttribute('aria-label', (wrap.dataset.removeLabel || 'Remove filter') + ': ' + (labels[g + ':' + v] || v));
            x.addEventListener('click', function () { toggle(g, v); });
            p.appendChild(x);
            actives.appendChild(p);
          });
        });
        if (total) {
          var c = document.createElement('button');
          c.type = 'button';
          c.className = 'ec-clearall';
          c.textContent = wrap.dataset.clearLabel || 'Clear all';
          c.addEventListener('click', reset);
          actives.appendChild(c);
        }
      }
      if (fcount) fcount.textContent = total ? '(' + total + ')' : '';
    }

    function toggle(g, v) {
      var i = state[g].indexOf(v);
      if (i > -1) state[g].splice(i, 1); else state[g].push(v);
      $all('[data-ec-opt][data-g="' + g + '"][data-v="' + v + '"]', wrap).forEach(function (b) {
        b.setAttribute('aria-pressed', state[g].indexOf(v) > -1 ? 'true' : 'false');
      });
      render();
    }

    function reset() {
      Object.keys(state).forEach(function (g) { state[g] = []; });
      $all('[data-ec-opt]', wrap).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      render();
    }

    $all('[data-ec-opt]', wrap).forEach(function (b) {
      b.addEventListener('click', function () { toggle(b.dataset.g, b.dataset.v); });
    });
    $all('[data-ec-reset]', wrap).forEach(function (b) { b.addEventListener('click', reset); });

    if (sort) {
      var num = function (c, k) { return parseFloat(c.dataset[k]) || 0; };
      var sorters = {
        rec: function (a, b) { return num(a, 'i') - num(b, 'i'); },
        rating: function (a, b) { return num(b, 'rating') - num(a, 'rating') || num(b, 'reviews') - num(a, 'reviews'); },
        reviews: function (a, b) { return num(b, 'reviews') - num(a, 'reviews'); },
        time: function (a, b) { return num(a, 't') - num(b, 't'); },
        easy: function (a, b) { return num(b, 'e') - num(a, 'e'); },
        new: function (a, b) { return num(b, 'new') - num(a, 'new'); },
        price: function (a, b) { return num(a, 'price') - num(b, 'price'); },
        avail: function (a, b) { return (a.dataset.status === 'out') - (b.dataset.status === 'out') || num(a, 'i') - num(b, 'i'); }
      };
      sort.addEventListener('change', function () {
        var fn = sorters[sort.value] || sorters.rec;
        cards.slice().sort(fn).forEach(function (c) { grid.appendChild(c); });
        render();
      });
    }

    var openBtn = wrap.querySelector('[data-ec-openf]');
    if (openBtn && side) {
      var close = function () {
        side.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        openBtn.setAttribute('aria-expanded', 'false');
        openBtn.focus();
      };
      openBtn.addEventListener('click', function () {
        side.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        openBtn.setAttribute('aria-expanded', 'true');
        var first = side.querySelector('button');
        if (first) first.focus();
      });
      $all('[data-ec-closef]', side).forEach(function (b) { b.addEventListener('click', close); });
      side.addEventListener('keyup', function (e) { if (e.key === 'Escape' && side.classList.contains('is-open')) close(); });
    }

    render();
  }

  /* ---------- product page ---------- */
  function initProduct(root) {
    var pdp = root.querySelector('[data-ec-pdp]');
    if (!pdp) return;

    var main = pdp.querySelector('[data-ec-gmain]');
    var thumbs = $all('[data-ec-thumb]', pdp);
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!dir) return;
        e.preventDefault();
        var n = thumbs[(i + dir + thumbs.length) % thumbs.length];
        n.focus();
        select(n);
      });
    });
    function select(t) {
      thumbs.forEach(function (x) { x.setAttribute('aria-selected', 'false'); x.tabIndex = -1; });
      t.setAttribute('aria-selected', 'true');
      t.tabIndex = 0;
      if (!main) return;
      main.classList.add('is-fading');
      setTimeout(function () {
        main.srcset = t.dataset.srcset || '';
        main.src = t.dataset.src;
        main.alt = t.dataset.alt || '';
        main.classList.remove('is-fading');
      }, reduceMotion ? 0 : 130);
    }

    var form = pdp.querySelector('product-form form, form[data-ec-form]');
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var total = pdp.querySelector('[data-ec-total]');
    var compare = pdp.querySelector('[data-ec-compare]');
    var save = pdp.querySelector('[data-ec-save]');
    var submit = form ? form.querySelector('[type="submit"]') : null;
    var submitText = submit ? submit.querySelector('span') : null;
    var mtotal = document.querySelector('[data-ec-mtotal]');
    var mnote = document.querySelector('[data-ec-mnote]');

    function applyVariant(input) {
      if (!input) return;
      var d = input.dataset;
      if (idInput) idInput.value = input.value;
      if (total) total.textContent = d.price;
      if (compare) { compare.textContent = d.compare || ''; compare.hidden = !d.compare; }
      if (mtotal) mtotal.textContent = d.price;
      if (mnote) mnote.textContent = d.short || '';
      if (save) {
        save.hidden = !d.upsell;
        save.textContent = d.upsell || '';
      }
      if (submit) {
        var ok = d.available === 'true';
        submit.disabled = !ok;
        submit.setAttribute('aria-disabled', ok ? 'false' : 'true');
        if (submitText) submitText.textContent = ok ? submit.dataset.addLabel : submit.dataset.soldLabel;
      }
      if (window.history && window.history.replaceState && pdp.dataset.updateUrl === 'true') {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        window.history.replaceState({}, '', url.toString());
      }
    }
    var radios = $all('[data-ec-variant]', pdp);
    radios.forEach(function (r) { r.addEventListener('change', function () { applyVariant(r); }); });
    applyVariant(radios.filter(function (r) { return r.checked; })[0]);

    var clamp = pdp.querySelector('[data-ec-clamp]');
    if (clamp) {
      var body = clamp.querySelector('.ec-rte');
      if (body && body.scrollHeight > 520) {
        clamp.classList.add('is-clamped');
        var btn = clamp.querySelector('[data-more]');
        if (btn) {
          btn.hidden = false;
          btn.addEventListener('click', function () {
            clamp.classList.remove('is-clamped');
            btn.hidden = true;
          });
        }
      }
    }

    var bar = document.querySelector('[data-ec-mbar]');
    var buy = pdp.querySelector('[data-ec-buy]');
    if (bar && buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); });
      }).observe(buy);
    } else if (bar) {
      bar.classList.add('is-on');
    }
  }

  function init(root) {
    root = root || document;
    initHeader(root);
    initMatch(root);
    initChips(root);
    initCollection(root);
    initProduct(root);
    observeReveal(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
